<template>
  <RequestPermissions @checked="checked" />
</template>

<script>
import RequestPermissions from '@huntica/huntica-interview-module/src/components/RequestPermissions.vue';

export default {
  name: 'InterviewRequestPermissions',
  components: {
    RequestPermissions,
  },
  methods: {
    checked(stream) {
      this.$emit('done', stream);
    },
  },
};
</script>
